module.exports = __webpack_public_path__ + "s15.no1.55698e49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s15.no1.jpg
// module id = Ygsx
// module chunks = 0